import { render, staticRenderFns } from "./PurchaseOrderMgmt.vue?vue&type=template&id=60ae9b04"
import script from "./PurchaseOrderMgmt.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderMgmt.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderMgmt.vue?vue&type=style&index=0&id=60ae9b04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports